import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteData,
  recordFiltering,
  findData,
} from '~/store/modules/justificativaTrocaModoOperacional/actions';

import Form from './form';

function JustificativaTrocaModoOperacional() {
  const redux = useSelector((state) => state.justificativaTrocaModoOperacional);

  const options = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'descricaojustificativatrocamodooperacional',
        label: t(
          's.configuracao.justificativatrocamodooperacional.descricaojustificativatrocamodooperacional'
        ),
        filter: { type: 'text' },
      },
      {
        id: 'statusjustificativatrocamodooperacional',
        label: t(
          's.configuracao.justificativatrocamodooperacional.statusjustificativatrocamodooperacional'
        ),
        formatted: (value) =>
          options.find((o) => o.label === value).value || '',
        filter: { type: 'select', options },
      },
    ],
    [options]
  );

  const fieldlist = [
    'descricaojustificativatrocamodooperacional',
    'statusjustificativatrocamodooperacional',
  ];

  const substituirHeader = {
    descricaojustificativatrocamodooperacional: t(
      's.configuracao.justificativatrocamodooperacional.descricaojustificativatrocamodooperacional'
    ),
    statusjustificativatrocamodooperacional: t(
      's.configuracao.justificativatrocamodooperacional.statusjustificativatrocamodooperacional'
    ),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      form={Form}
      keys={['idjustificativatrocamodooperacional']}
      detach="descricaojustificativatrocamodooperacional"
      excel
      pdf
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'justificativastrocasmodosoperacionals',
          formato,
          fields: fieldlist,
          redux,
          headers: substituirHeader,
          title: 'Relatório de Just. Troca Modo Operacional',
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          substituirValores: {
            statusjustificativatrocamodooperacional: {
              L: t('s.geral.opcoes.liberado'),
              B: t('s.geral.opcoes.bloqueado'),
            },
          },
        })
      }
    />
  );
}

export default JustificativaTrocaModoOperacional;
